import React from 'react';
import { useMessages, useEnhancedMutation } from 'src/modules/common/application';
import { useTranslation } from 'react-i18next';
import Button from 'src/modules/common/components/Button/Button';
import { CALCULATE_COLLECT_OVERVIEW_PROGRESS_STATUS } from 'src/services/graphql/mutations/collect';

const CalculateCollectOverviewProgressStatus = ({ companyId }: { companyId: string }) => {
  const { setErrorMessage, setSuccessMessage } = useMessages();
  const { t } = useTranslation();

  const [calculateCollectOverviewProgressStatus, { loading }] = useEnhancedMutation(
    CALCULATE_COLLECT_OVERVIEW_PROGRESS_STATUS,
    {
      onCompleted: () => setSuccessMessage(t('messages.calculation.success')),
      onError: () => setErrorMessage(t('messages.calculation.error')),
    }
  );

  const handleClick = () => {
    calculateCollectOverviewProgressStatus({
      variables: {
        companyId,
      },
    });
  };

  return (
    <Button
      sx={{
        width: '100%',
        mt: 2,
      }}
      onClick={handleClick}
      loading={loading}
    >
      Calculate Collect Overview Progress & Status
    </Button>
  );
};

export default CalculateCollectOverviewProgressStatus;
